import { createContext, useContext } from 'react';
import { createClient } from '@segment/api/staticSiteBackend/client';
export var StaticSiteBackendContext = /*#__PURE__*/createContext(null);
export var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
export var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = useContext(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

export var createStaticSiteBackend = function createStaticSiteBackend() {
  return createClient();
};